export const PERSON_DEFAULT_ICON = 'user';
export const CREDENTIAL_DEFAULT_ICON = 'id-card-clip';
// Make sure this list stays in sync with https://www.qumulex.com/kb/importing-cardholders-to-qumulex
export const PERSON_IMPORT_CSV_HEADERS = [
  'CardValue',
  'LastName',
  'FirstName',
  'Suffix',
  'Salutation',
  'JobTitle',
  'Department',
  'EmployeeID',
  'LicensePlate',
  'GroupID',
  'Email',
  'RoleID'
];


